module.exports = __webpack_public_path__ + "img/09_choice 3.b924701c.png";